import { createSlice } from "@reduxjs/toolkit";

import {
  getDepartmentThunk,
  createDepartmentThunk,
  updateDepartmentThunk,
  deleteDepartmentThunk,
} from "state/action/department";

// Initial state
const initialState = {
  // Get Department inisial state
  getDepartment: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Department inisial state
  createDepartment: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Department inisial state
  updateDepartment: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Department inisial state
  deleteDepartment: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  createDepartmentInputBody: {
    name: "",
    email: "",
    description: "",
    directorate: "",
    division: "",
    represented_by: [
      {
        name: "",
        title: "",
        email: "",
        role: "",
      },
    ],
    divisi: "",
    permissions: [],
    code: "",
  },
  addRepresentedBy: {
    name: "",
    title: "",
    email: "",
    role: "",
  },
  selectedDepartment: {},
  // Department object value
  department_object_value: "",
};

export const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    // Reducer generik untuk update field
    setRepresentativeField: (state, action) => {
      const { field, value } = action.payload;
      state.addRepresentedBy[field] = value;
    },
    // Reset form setelah submit atau cancel
    resetRepresentativeForm: (state) => {
      state.addRepresentedBy = initialState.addRepresentedBy;
    },
    // Reducer untuk field di level atas
    setDepartmentField: (state, action) => {
      const { field, value } = action.payload;
      state.createDepartmentInputBody[field] = value;
    },

    // --- Reducers untuk array 'represented_by' ---
    addRepresentative: (state) => {
      state.createDepartmentInputBody.represented_by.push({
        name: "",
        title: "",
      });
    },
    updateRepresentative: (state, action) => {
      const { index, field, value } = action.payload;
      state.createDepartmentInputBody.represented_by[index][field] = value;
    },
    removeRepresentative: (state, action) => {
      const index = action.payload;
      state.createDepartmentInputBody.represented_by.splice(index, 1);
    },

    // --- Handle Permissions ---
    setPermissions: (state, action) => {
      state.createDepartmentInputBody.permissions = action.payload;
    },
    resetDepartmentForm: (state) => {
      state.createDepartmentInputBody = initialState.createDepartmentInputBody;
    },

    setGetDepartmentObjectValue: (state, action) => {
      return {
        ...state,
        department_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetDepartmentObjectValue: (state, _) => {
      return {
        ...state,
        department_object_value: "",
      };
    },
    setCreateDepartmentInputBody: (state, action) => {
      return {
        ...state,
        createDepartmentInputBody: action.payload,
      };
    },
    setSelectedDepartment: (state, action) => {
      return {
        ...state,
        selectedDepartment: action.payload,
      };
    },
    setClearCreateDepartmentInputBody: (state, _) => {
      return {
        ...state,
        createDepartmentInputBody: {
          name: "",
          email: "",
          description: "",
          directorate: "",
          division: "",
          represented_by: [
            {
              name: "",
              title: "",
            },
          ],
          code: "",
        },
      };
    },
    setClearCreateDepartment: (state, _) => {
      return {
        ...state,
        createDepartment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearGetDepartment: (state, _) => {
      return {
        ...state,
        getDepartment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateDepartment: (state, _) => {
      return {
        ...state,
        updateDepartment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteDepartment: (state, _) => {
      return {
        ...state,
        deleteDepartment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllDepartmentState: (state, _) => {
      return {
        ...state,
        // Get Department inisial state
        getDepartment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Department inisial state
        createDepartment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Department inisial state
        updateDepartment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Department inisial state
        deleteDepartment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Department object value
        Department_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Department reducer
      .addCase(getDepartmentThunk.pending, (state, _) => {
        return {
          ...state,
          getDepartment: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getDepartmentThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getDepartment: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getDepartmentThunk.rejected, (state, action) => {
        return {
          ...state,
          getDepartment: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Department reducer
      .addCase(createDepartmentThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createDepartmentThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createDepartmentThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Department reducer
      .addCase(updateDepartmentThunk.pending, (state, _) => {
        return {
          ...state,
          updateDepartment: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateDepartmentThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateDepartment: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateDepartmentThunk.rejected, (state, action) => {
        return {
          ...state,
          updateDepartment: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const departmentAction = {
  ...departmentSlice.actions,
  getDepartmentThunk,
  createDepartmentThunk,
  updateDepartmentThunk,
  deleteDepartmentThunk,
};

export function selectDepartmentObjectValue(state) {
  return state?.department?.department_object_value;
}

export function selectDepartment(state) {
  return state?.department;
}

export default departmentSlice.reducer;
